export enum TypeProductAwardRatingDisplay {
  None = 'None',
  Stars = 'Stars',
  Fraction = 'Fraction',
  Percentage = 'Percentage',
}
